import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { renameGlobalAccountPayment } from 'apps/auth/actions/extraAction';
import { setNewForm } from 'apps/auth/actions/formAction';
import { renamePayment } from 'apps/auth/actions/historyAction';
import ComplexPopup from 'apps/auth/components/common/Popup/ComplexPopup';
import { ComplexPopupRow } from 'apps/auth/components/common/Popup/styles';
import Form from 'apps/auth/components/form-multi/Form';
import InputText from 'apps/auth/components/form-multi/InputText';
import { getField } from 'apps/auth/components/form-multi/utils';
import Loading from 'apps/auth/components/utils/Loading';
import { RENAME_PAYMENT_URL } from 'apps/auth/constants/UrlConstants';
import { useCheck, useForm, usePageMessages } from 'apps/auth/hooks/selectors';

const FORM_NAME = 'renamePopup';

const RenamePopup = ({
    isGlobalAccount = false,
    item,
    popupRef = null,
    renameGlobalAccountPayment,
    renamePayment,
    setNewForm,
    urlAction = RENAME_PAYMENT_URL,
}) => {
    const { paymentId, toProviderName: renameText } = useCheck() || {};
    const { renameHeader: header, renamePlaceholder: placeholder, renameButton: renameBtnText } = usePageMessages();
    const form = useForm(FORM_NAME);

    useEffect(() => {
        const nameField = getField('name', isGlobalAccount ? item.payTitle : renameText, '', true, false, placeholder, 'text');
        const paymentIdField = getField('paymentId', '' + (isGlobalAccount ? item.payId : paymentId));

        setNewForm(FORM_NAME, {
            [nameField.name]: nameField,
            [paymentIdField.name]: paymentIdField,
        });
    }, []);

    const onSubmitHandler = () => {
        if (isGlobalAccount) {
            renameGlobalAccountPayment(item.payId, form.fields.name.value);
        } else {
            renamePayment(paymentId, form.fields.name.value);
        }
        popupRef.current?.close();
    };

    if (!form) {
        return <Loading />;
    }

    return (
        <ComplexPopup
            primaryButtonType="submit"
            primaryButtonForm="transaction_rename_form_id"
            primaryButtonTabIndex="1002"
            primaryButtonText={renameBtnText}
            textCenter
            popupRef={popupRef}
        >
            <ComplexPopupRow>
                <p>{header}</p>
            </ComplexPopupRow>
            <Form id="transaction_rename_form_id" action={urlAction} formName={FORM_NAME} fields={form.fields} onSubmitHandler={onSubmitHandler}>
                <InputText field={form.fields.name} formName={FORM_NAME} focus={true} isNewInput />
            </Form>
        </ComplexPopup>
    );
};

RenamePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { setNewForm, renamePayment, renameGlobalAccountPayment })(RenamePopup);
